export default function Container({className = '', children}) {
    return (
        <section className={`w-full max-w-[1440px] mx-auto px-5 lg:px-12 xl:px-28 ${className}`}>
            {children}
        </section>
    )
}